var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { Box } from "rebass";
import { css } from "styled-components";
import CollectionMasteryLevel2BackgroundSvg from "assets/svg/collection-mastery-level-2-background.svg";
import CollectionMasteryLevel3BackgroundSvg from "assets/svg/collection-mastery-level-3-background.svg";
import CollectionMasteryLevel4BackgroundSvg from "assets/svg/collection-mastery-level-4-background.svg";
import CollectionMasteryLevel5BackgroundSvg from "assets/svg/collection-mastery-level-5-background.svg";
import styled from "styled-components";
var masteryLevelBackgroundStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  height: 100%;\n  width: 100%;\n\n  & svg {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  height: 100%;\n  width: 100%;\n\n  & svg {\n    width: 100%;\n    height: 100%;\n  }\n"])));
var MasteryLevel2Background = function () {
    var idPrefix = React.useId();
    return (React.createElement("svg", { width: "88", height: "298", viewBox: "0 0 88 298", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { width: "88", height: "298", fill: "url(#".concat(idPrefix, "_linear_0)") }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "".concat(idPrefix, "_linear_0"), x1: "44", y1: "0", x2: "44", y2: "298", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#EEEEEE" }),
                React.createElement("stop", { offset: "1", stopColor: "white" })))));
};
var MasteryLevel3Background = function () {
    var idPrefix = React.useId();
    return (React.createElement("svg", { width: "450", height: "300", viewBox: "0 0 450 300", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { x: "418.042", y: "-63.1816", width: "181.521", height: "573.903", transform: "rotate(60 418.042 -63.1816)", fill: "url(#".concat(idPrefix, "_linear_0)") }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "".concat(idPrefix, "_linear_0"), x1: "508.802", y1: "-63.1816", x2: "508.802", y2: "510.722", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#FFFBEA" }),
                React.createElement("stop", { offset: "1", stopColor: "#FFF0B7" })))));
};
var MasteryLevel4Background = function () {
    var idPrefix = React.useId();
    return (React.createElement("svg", { width: "450", height: "300", viewBox: "0 0 450 300", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { opacity: "0.25", d: "M276.985 103.665L466.939 293.619L397.562 362.996L228.247 193.681L45.3779 376.551L-24 307.173L178.985 104.188V-85H276.985V103.665Z", fill: "url(#".concat(idPrefix, "_linear_0)") }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "".concat(idPrefix, "_linear_0"), x1: "228", y1: "-2", x2: "232", y2: "292.5", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#2FDDBA" }),
                React.createElement("stop", { offset: "1", stopColor: "#DFFFF9" })))));
};
var MasteryLevel5Background = function () {
    var idPrefix = React.useId();
    return (React.createElement("svg", { width: "450", height: "300", viewBox: "0 0 450 300", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M255.999 141.502L448.749 30.2174L448.749 252.786L255.999 141.502Z", fill: "url(#".concat(idPrefix, "_linear_0)") }),
        React.createElement("path", { d: "M198.999 141.5L6.24852 252.784L6.24853 30.2157L198.999 141.5Z", fill: "url(#".concat(idPrefix, "_linear_1)") }),
        React.createElement("path", { d: "M225.5 173.002L325.526 345.502L125.475 345.502L225.5 173.002Z", fill: "url(#".concat(idPrefix, "_linear_2)") }),
        React.createElement("path", { d: "M225.501 138L125.475 -34.5L325.526 -34.5L225.501 138Z", fill: "url(#".concat(idPrefix, "_linear_3)") }),
        React.createElement("path", { d: "M241.454 75.5132C247.385 78.368 252.574 81.9184 258.015 85.6288C268.112 92.2325 277.693 93.4948 289.475 94.372C293.565 94.8368 293.565 94.8368 297.332 96.7257C297.553 105.146 297.686 113.566 297.803 121.989C297.866 124.353 297.929 126.717 297.994 129.153C298.234 152.079 291.883 167.273 278.498 185.501C277.138 187.371 275.778 189.241 274.378 191.167C263.264 204.069 243.385 223.292 226.084 226C218.2 224.9 213.192 221.173 207.044 216.43C205.879 215.559 204.715 214.687 203.515 213.789C200.234 211.314 196.984 208.803 193.742 206.278C192.384 205.25 191.027 204.223 189.629 203.164C173.325 190.1 158.309 170.478 154.189 149.613C154.035 145.513 153.986 141.409 154.005 137.306C154.011 134.944 154.017 132.582 154.023 130.149C154.039 127.69 154.055 125.231 154.071 122.697C154.079 120.209 154.088 117.72 154.097 115.157C154.119 109.013 154.15 102.869 154.189 96.7257C159.22 94.2027 163.908 93.9972 169.492 93.3022C182.012 91.4256 190.937 87.8846 201.393 80.9141C214.036 72.9221 226.975 70.7218 241.454 75.5132Z", fill: "url(#".concat(idPrefix, "_linear_4)") }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "".concat(idPrefix, "_linear_0"), x1: "255.999", y1: "141.502", x2: "512.999", y2: "141.502", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#F0DEFF" }),
                React.createElement("stop", { offset: "1", stopColor: "white" })),
            React.createElement("linearGradient", { id: "".concat(idPrefix, "_linear_1"), x1: "198.999", y1: "141.5", x2: "-58.0015", y2: "141.5", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#F0DEFF" }),
                React.createElement("stop", { offset: "1", stopColor: "white" })),
            React.createElement("linearGradient", { id: "".concat(idPrefix, "_linear_2"), x1: "225.501", y1: "403.002", x2: "225.5", y2: "173.002", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "white" }),
                React.createElement("stop", { offset: "1", stopColor: "#E9D3FF" })),
            React.createElement("linearGradient", { id: "".concat(idPrefix, "_linear_3"), x1: "225.5", y1: "-92", x2: "225.501", y2: "138", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "white" }),
                React.createElement("stop", { offset: "1", stopColor: "#E9D3FF" })),
            React.createElement("linearGradient", { id: "".concat(idPrefix, "_linear_4"), x1: "226.001", y1: "73", x2: "226.001", y2: "226", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#F1E7FF" }),
                React.createElement("stop", { offset: "1", stopColor: "#F7F3FE" })))));
};
var MasteryLevelBackgrounds = {
    2: MasteryLevel2Background,
    3: MasteryLevel3Background,
    4: MasteryLevel4Background,
    5: MasteryLevel5Background,
};
export var MasteryLevelBackground = function (_a) {
    var _b = _a.masteryLevel, masteryLevel = _b === void 0 ? 0 : _b, _c = _a.css, css = _c === void 0 ? "" : _c;
    var IconComponent = MasteryLevelBackgrounds[masteryLevel];
    if (!IconComponent) {
        return undefined;
    }
    return (React.createElement(Box, { css: [masteryLevelBackgroundStyle, css] },
        React.createElement(IconComponent, { "aria-hidden": "true" })));
};
export var getMasteryLevelBackgroundColor = function (masteryLevel) {
    switch (masteryLevel) {
        case 0:
            return "white";
        case 1:
            return "#FFF7F4";
        case 2:
            return "#F5F5F5";
        case 3:
            return "#FFF9E4";
        case 4:
            return "#F2FFF8";
        case 5:
            return "#F9F5FF";
        default:
            return undefined;
    }
};
var collectionMasteryLevelBackgroundStyle = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 0;\n"])));
var CollectionMasteryLevel2Background = styled(CollectionMasteryLevel2BackgroundSvg)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transform: translate(28px, -15px);\n  ", "\n"], ["\n  transform: translate(28px, -15px);\n  ", "\n"])), collectionMasteryLevelBackgroundStyle);
var CollectionMasteryLevel3Background = styled(CollectionMasteryLevel3BackgroundSvg)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  top:50%;\n  transform: translate(30%, -50%);\n"], ["\n  ", "\n  top:50%;\n  transform: translate(30%, -50%);\n"])), collectionMasteryLevelBackgroundStyle);
var CollectionMasteryLevel4Background = styled(CollectionMasteryLevel4BackgroundSvg)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  top:50%;\n  transform: translate(40%, -50%);\n"], ["\n  ", "\n  top:50%;\n  transform: translate(40%, -50%);\n"])), collectionMasteryLevelBackgroundStyle);
var CollectionMasteryLevel5Background = styled(CollectionMasteryLevel5BackgroundSvg)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  top:50%;\n  transform: translate(20%, -50%);\n"], ["\n  ", "\n  top:50%;\n  transform: translate(20%, -50%);\n"])), collectionMasteryLevelBackgroundStyle);
var CollectionMasteryLevelBackgrounds = {
    2: CollectionMasteryLevel2Background,
    3: CollectionMasteryLevel3Background,
    4: CollectionMasteryLevel4Background,
    5: CollectionMasteryLevel5Background,
};
export var CollectionMasteryLevelBackground = function (_a) {
    var _b = _a.masteryLevel, masteryLevel = _b === void 0 ? 0 : _b;
    var IconComponent = CollectionMasteryLevelBackgrounds[masteryLevel];
    if (!IconComponent) {
        return undefined;
    }
    return React.createElement(IconComponent, { "aria-hidden": "true" });
};
export var getCollectionMasteryLevelBackgroundColor = function (masteryLevel) {
    switch (masteryLevel) {
        case 0:
            return "white";
        case 1:
            return "#FFF7F4";
        case 2:
            return "#F5F5F5";
        case 3:
            return "#FFFBEC";
        case 4:
            return "#F2FFF8";
        case 5:
            return "#F9F5FF";
        default:
            return undefined;
    }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
